import * as React from "react";
import { Path, G, ClipPath, Defs, Rect, Mask } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const MEIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="ME" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#E8AA00"
        fillRule="evenodd"
        d="M0 0h16v12H0V0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#C51918"
        fillRule="evenodd"
        d="M1.6 1.6h12.8v8.8H1.6V1.6Z"
        clipRule="evenodd"
      />
      <Mask
        id="b"
        width={14}
        height={10}
        x={1}
        y={1}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <Path
          fill="#fff"
          fillRule="evenodd"
          d="M1.6 1.6h12.8v8.8H1.6V1.6Z"
          clipRule="evenodd"
        />
      </Mask>
      <G mask="url(#b)">
        <Path
          fill="#1E5E91"
          fillRule="evenodd"
          d="M10.115 7.876c.204 0 .37-.17.37-.379a.374.374 0 0 0-.37-.378c-.203 0-.369.17-.369.378 0 .21.166.379.37.379Z"
          clipRule="evenodd"
        />
        <Path
          fill="#F6C540"
          d="M10.039 3.087s1.388 1.953.42 3.079c-.969 1.125-1.68.786-1.68.786l.397.356-.113.098h.331l-.122.081.09.04.095.041c-.007.005-.252.188 0 .188.084 0 .18-.005.274-.005.027 0-.117-.291-.09-.29.05.002.184.211.252.258.036.024.266-.086.296-.07.075.037.031.123.02.19-.005.027.32-.208.334-.19.027.034.097.08-.26.357 0 .211.03.26-.064.26-.116 0-.395.203-.579 0-.183-.204-.464-.51-.464-.51v.15l-.333-.338-.065.188-.448-.515-.121.067s.413 1.139.634 1.147c.22.008-.678.431-.884.716-.032.043-.055-.027-.073-.178-.019.15-.04.221-.073.178-.206-.285-1.103-.708-.883-.716.22-.008.633-1.147.633-1.147l-.12-.067-.449.515-.064-.188-.333.338v-.15s-.282.306-.465.51c-.183.202-.462 0-.577 0-.116 0-.154-.162 0-.36.154-.198.505-.15.76-.15.256 0 0-.188 0-.188l.095-.042.09-.039-.122-.081h.33l-.111-.098.397-.356s-.712.34-1.68-.786c-.965-1.122.41-3.065.42-3.08 0 0 .207 1.168.975 1.953 0 .095-.209.266-.276.388-.068.123.163.193.276.193.112 0 .113.363.22.201.107-.16-.102-.509-.107-.517l.342-.36.115-.233h-.115v-.24l-.081.067s-.09-.215-.26-.215c-.173 0-.226-.099-.226-.099h.225c.113 0-.018-.148-.113-.226-.095-.078-.299.077-.299-.068 0-.144.186-.082.299-.163.112-.08.285 0 .455 0h.278c.1 0-.163.163-.163.163l.163.145.242.248-.12.072.25.242c-.004.005-.084.138 0 .138.036 0 .057.032.072.068.014-.036.037-.068.073-.068.084 0 .001-.136 0-.138l.25-.242-.121-.072.242-.248.163-.145c-.008-.004-.261-.162-.163-.163h.278c.17 0 .343-.08.455 0 .113.081.299.019.3.163 0 .145-.205-.01-.3.068-.094.078-.225.226-.113.226h.226s-.054.099-.226.099c-.172 0-.26.215-.26.215l-.082-.068v.24h-.115l.115.234.342.36c-.006.01-.213.358-.107.517.108.162.108-.201.22-.201.113 0 .344-.07.277-.193-.068-.122-.276-.293-.277-.388.767-.784.975-1.947.976-1.952Z"
        />
        <Path
          fill="#F6C540"
          fillRule="evenodd"
          d="m6.217 8.515-.438-.767s-.572-1.32-.572-1.48c0-.16-.23-.634-.23-.496v.497l.965 2.174v.172h.13l.145-.1Z"
          clipRule="evenodd"
        />
        <Path
          fill="#F6C540"
          d="m9.72 7.482.068-.22.813.244-.067.221-.813-.245Z"
        />
        <Path
          fill="#F6C540"
          d="m10.154 7.08.22.072-.215.689-.22-.072.215-.689ZM10.359 6.855l-.02.077.085.021-.01.046-.086-.021-.022.086-.047-.01.022-.087-.086-.02.01-.048.087.02.02-.074.047.01ZM7.967 2.611c.06.018.115.04.163.063l.002-.019c.386.035.586.197.565.48-.018.235-.137.356-.335.353v.178s-.324.124-.485.124c-.162 0-.485-.124-.485-.124v-.179c-.163-.02-.26-.14-.276-.352-.022-.284.178-.445.564-.48l.001.02c.05-.024.105-.045.166-.064l.024.083h.073l.023-.083Zm.393.235c.102.134.106.302.006.502.123.003.18-.066.192-.222.01-.134-.052-.225-.198-.28Zm-.905-.002c-.148.054-.212.148-.201.282.01.134.054.203.144.218l.042-.011c-.092-.194-.086-.359.015-.489Zm.51.414c.105.013.231.044.313.066l-.041-.023c.138-.264.057-.433-.272-.541v.498Zm-.137-.49c-.31.108-.385.273-.252.529.081-.02.176-.037.252-.043v-.487Z"
        />
        <Path
          fill="#3D58DB"
          fillRule="evenodd"
          d="M7.877 2.76a.162.162 0 1 0 0-.323.162.162 0 0 0 0 .323Z"
          clipRule="evenodd"
        />
        <Path
          fill="#F6C540"
          d="M7.9 2.249v.079h.087v.047H7.9v.09h-.048v-.089h-.089V2.33l.089-.001V2.25l.049-.001Z"
        />
        <Path
          fill="#1E5E91"
          fillRule="evenodd"
          d="M6.977 5.18s.569-.108.877-.108c.276 0 .877.108.877.108 0 .68.191 1.096 0 1.56-.192.465-.66.242-.87.686-.271-.421-.637-.19-.884-.79-.247-.6.15-.877 0-1.456Z"
          clipRule="evenodd"
        />
        <Mask
          id="c"
          width={3}
          height={3}
          x={6}
          y={5}
          maskUnits="userSpaceOnUse"
          style={{
            maskType: "luminance",
          }}
        >
          <Path
            fill="#fff"
            fillRule="evenodd"
            d="M6.977 5.18s.569-.108.877-.108c.276 0 .877.108.877.108 0 .68.191 1.096 0 1.56-.192.465-.66.242-.87.686-.271-.421-.637-.19-.884-.79-.247-.6.15-.877 0-1.456Z"
            clipRule="evenodd"
          />
        </Mask>
        <G mask="url(#c)">
          <Path fill="#5EAA22" d="M6.977 6.599h1.754v.851H6.977z" />
          <Path
            fill="#F6C540"
            d="M7.848 5.356s.09.158 0 .384c-.09.227.15.115.376.115.225 0 .195-.04.405.282.057.087.051.141.017.175.003.087-.088.16-.264.206l-.024-.092c.096-.025.153-.05.178-.076-.132.009-.312-.054-.312-.138 0-.04-.045-.065-.114-.079v.02c.002 0 .01-.01.012-.015a.34.34 0 0 0 .005.023l.012.046c.012.05.017.09.017.132 0 .12-.101.19-.285.217l-.014-.094c.144-.021.207-.064.207-.123a.445.445 0 0 0-.015-.108l-.012-.048a.212.212 0 0 1-.007-.046l.002-.015a2.94 2.94 0 0 0-.401.003c-.026.223-.14.366-.343.42l-.023-.092c.159-.042.248-.147.272-.324-.06.004-.11.008-.141.008-.093 0-.082-.07-.037-.163-.173-.011-.218-.198-.151-.533l.09.018c-.058.294-.025.423.077.423v.064c.035-.065.08-.14.12-.206.108-.175.067-.083 0-.225-.066-.141.347-.159.353-.16Zm.653.136-.014.094c-.203-.032-.289-.009-.289.047 0 .061.091.1.296.098h.007l.007.002c.157.049.157.149.002.205l-.031-.09a.41.41 0 0 0 .034-.013l-.026-.01c-.246.001-.382-.057-.382-.192 0-.142.143-.18.396-.14Z"
          />
        </G>
      </G>
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
